import { useEffect, useState } from "react";
const productIntro = [
    {
        image: "images/AI01.png",
        title: '智能理財機器人核心演算法\n(AI ROBO)',
        description: '協助投信投顧與銀行建置智能理財系統，多年金融市場經驗與實作成績，推動智能理財結合財富管理並系統化自動監控客戶投資組合。'
    },
    {
        image: "images/B2B.png",
        title: 'B2C智能理財系統導入',
        description: '協助投信投顧與銀行建置智能理財系統，多年金融市場經驗與實作成績，推動智能理財結合財富管理並系統化自動監控客戶投資組合。'
    },
    {
        image: "images/AI2.png",
        title: '金融服務數位化',
        description: '以平台服務的商業模式提供其他金融機構導入金融科技的金融資訊服務業務（例如：協助金融機構平台建置和維運並提供金融科技導入服務）。'
    },
]

const performance = [
    {
        title: '富蘭克林投顧  國民理財機器人',
        image: 'images/case-B2b.png'
    },
    {
        title: '華南銀行  智能理財服務系統',
        image: 'images/hncb.png'
    },
    {
        title: '上海商銀 智能理財建置中',
        image: 'images/shanghai.png'
    },
]
const windowWidth = window.innerWidth;

function Home() {

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const updateDimension = () => {
            setWidth(window.innerWidth);
        }
        window.addEventListener('resize', updateDimension);

        return (() => {
            window.removeEventListener('resize', updateDimension);
        })
    }, [width])

    useEffect(() => console.log(width), [width])

    return (
        <div className="w-full h-full relative" style={{ backgroundColor: 'rgb(66,150,175)' }}>
            <div className="flex h-40 w-full items-center justify-center border-b-2">
                <span className=" text-white font-bold text-3xl text-center">富蘭克林金融科技</span>
            </div>
            <div className="w-full items-center border-b-4 relative pb-6">
                <div className="mt-10 w-full text-center">
                    <div className=" bg-white h-0.5 w-10 mx-auto mb-2" />
                    <span className="text-white font-bold text-4xl">富蘭克林金科產品介紹</span>
                    <br />
                    <span className="text-white text-xs">FT Fintech product description</span>
                    <div className={`flex w-full h-full mt-10 justify-around mb-10 ${width < 769 ? 'flex-col items-center' : ''}`}>
                        {
                            productIntro.map((item, index) =>
                                <div className={`${width < 769 ? 'mb-10 w-2/4' : 'w-1/5'}`}>
                                    <img key={`productIntro${index}`} src={item.image} className="w-5/6 mx-auto mb-2" />
                                    <div className="text-white h-12">{item.title}</div>
                                    <div className=" bg-white h-px w-4/6 mx-auto inline-block" />
                                    <div className="text-white">{item.description}</div>
                                </div>
                            )
                        }
                    </div>
                    <div className="border-2 w-auto px-2 py-2 text-white border-x-0" style={{ letterSpacing: 6 }}>{'結合20年投顧經驗結晶的Fintech專業人材'}</div>
                </div>
                <img src="images/City.png" className="absolute bottom-0 w-5/6 left-1/2 -translate-x-1/2" />
            </div>
            <div className="bg-white relative w-full py-10">
                <div className="flex flex-col ml-10">
                    <img src="images/case.png" alt="" className="flex h-auto mb-5 w-96" />
                    <span className="font-bold" style={{ color: 'rgb(15,150,175)' }}>B2C智能理財系統導入</span>
                </div>
                <div className={`flex ${width < 769 ? 'flex-col items-center' : 'flex-row'} w-fullh-full mt-10 mb-10 justify-between mx-10 `}>
                    {
                        performance.map((item, index) =>
                            <div key={`performance${index}`} className={`flex flex-col ${width < 769 ? 'mb-10 w-3/4' : 'w-1/4'}`}>
                                <div className="flex flex-row items-center w-full">
                                    <div className="w-8 h-8 rounded-md" style={{ backgroundColor: 'rgb(66,150,175)' }}></div>
                                    <div className="px-4 border-2 py-0.5 rounded-md border-l-0">{item.title}</div>
                                </div>
                                <img src={item.image} className="flex w-full h-auto mt-4" alt="" />
                                <div className="w-full h-2 mt-2" style={{ backgroundColor: 'rgb(66,150,175)' }} />
                            </div>
                        )
                    }
                </div>
            </div>
            <div className="flex flex-row w-full items-center justify-around">
                <div className=" text-white text-4xl">
                    富蘭克林金融科技
                </div>
                <div className={`flex flex-col ${width < 426 ? 'text-lg' : 'text-xl'} text-white`}>
                    <div>
                        電話：{width < 376 && <br/>}(02)27726986 分機 581
                    </div>
                    <div>
                        地址：106台北市大安區忠孝東路四段87號10樓之8
                    </div>
                    <div>
                        Email：{width < 426 && <br />}ft-service@ftfintech.com
                </div>
            </div>
        </div>
        </div >
    );
}

export default Home;
